"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGFDWMarginCheckInfo = void 0;
const react_1 = require("react");
const lodash_1 = require("lodash");
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const apis_1 = require("../apis");
const trade_utils_lib_1 = require("trade_utils_lib");
const TradeAPILib_1 = require("TradeAPILib");
const parseLiquidationForMode_1 = require("../Tools/parseLiquidationForMode");
const parseParamsToRequest = (_params) => {
    if (!_params.open_price || !Number(_params.open_price)) {
        throw { code: -1, message: "no open price" };
    }
    //!Number(_params.extra_margin) && _params.type === "out" 在充入保证金时, 没传提取金额, 不用先请求. 提取先请求是为了要最大提取金额
    if (!_params.extra_margin || !_params.type || !_params.orderId || (_params.type === "in" && !Number(_params.extra_margin))) {
        throw { code: -1, message: "params is invalid" };
    }
    return _params;
};
const queryAPI = (params) => {
    const { mode = TradeAPILib_1.GridFuturesMode.normal } = params;
    return (0, rxjs_1.of)(params).pipe((0, operators_1.map)((res) => {
        return parseParamsToRequest(res);
    }), (0, operators_1.mergeMap)((request) => {
        return (0, apis_1.DWMarginParamsCheckAPI)(request);
    }), (0, operators_1.map)((res) => {
        const { up: esUpUI, down: esDownUI } = (0, parseLiquidationForMode_1.parseLiquidationDisplayForMode)({
            mode: mode,
            liquidationUp: res.estimate_liquidation_price_up,
            liquidationDown: res.estimate_liquidation_price_down,
            precision: params.precision,
        });
        const { up: esAftUpUI, down: esAftDownUI } = (0, parseLiquidationForMode_1.parseLiquidationDisplayForMode)({
            mode: mode,
            liquidationUp: res.estimate_liquidation_price_up_after,
            liquidationDown: res.estimate_liquidation_price_down_after,
            precision: params.precision,
        });
        const value = Object.assign(Object.assign({}, res), { estimate_liquidation_price_up: res.estimate_liquidation_price_up || "0", estimate_liquidation_price_down: res.estimate_liquidation_price_down || "0", estimate_liquidation_price_up_after: res.estimate_liquidation_price_up_after || "0", estimate_liquidation_price_down_after: res.estimate_liquidation_price_down_after || "0", estimate_liquidation_price_up_for_ui: esUpUI, estimate_liquidation_price_down_for_ui: esDownUI, estimate_liquidation_price_up_after_for_ui: esAftUpUI, estimate_liquidation_price_down_after_for_ui: esAftDownUI, max_amount: (0, lodash_1.isEmpty)(res.max_amount)
                ? res.max_amount
                : trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(res.max_amount, params.precisionCost || params.precision || 10, trade_utils_lib_1.SafeDecimal.ROUND_DOWN) });
        return value;
    }));
};
const useGFDWMarginCheckInfo = (params) => {
    const [checkInfo, setCheckInfo] = (0, react_1.useState)();
    const [loading, setLoading] = (0, react_1.useState)(false);
    const { open_price, extra_margin, orderId, type } = params;
    const depsExPrice = [type, orderId, Number(extra_margin)];
    const requestRef = (0, react_1.useRef)(params);
    requestRef.current = params;
    const debounceFn = (0, react_1.useRef)((0, lodash_1.debounce)(() => {
        const sub = (0, rxjs_1.of)(requestRef.current)
            .pipe((0, operators_1.mergeMap)((req) => {
            setLoading(true);
            return queryAPI(req);
        }))
            .subscribe({
            next: (data) => {
                setCheckInfo(data);
                setLoading(false);
            },
            error: (error) => {
                setLoading(false);
                console.log(`useAdjustParamsCheckInfo debounce: ${JSON.stringify(error)}`);
            },
        });
        return sub;
    }, 500));
    // 用户输入防抖
    (0, react_1.useEffect)(() => {
        var _a;
        const sub = (_a = debounceFn.current) === null || _a === void 0 ? void 0 : _a.call(debounceFn);
        return () => sub === null || sub === void 0 ? void 0 : sub.unsubscribe();
    }, depsExPrice);
    const throttleDepensOnPriceFn = (0, react_1.useRef)((0, lodash_1.throttle)(() => {
        const sub = queryAPI(requestRef.current).subscribe({
            next: (data) => {
                setCheckInfo(data);
            },
            error: (error) => {
                console.log(`useAdjustParamsCheckInfo throttle: ${JSON.stringify(error)}`);
            },
        });
        return sub;
    }, 5000));
    // 当前价格变更节流
    (0, react_1.useEffect)(() => {
        var _a;
        // 只有在当前参数合理时，才去根据价格刷新数据
        if (!checkInfo || !checkInfo.check_result) {
            return;
        }
        if (!Number(extra_margin) // 没有投资额
        ) {
            return;
        }
        const sub = (_a = throttleDepensOnPriceFn.current) === null || _a === void 0 ? void 0 : _a.call(throttleDepensOnPriceFn);
        return () => sub === null || sub === void 0 ? void 0 : sub.unsubscribe();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open_price]);
    const queryCheckInfo = (0, react_1.useCallback)(() => {
        return queryAPI(requestRef.current).pipe((0, operators_1.tap)((value) => {
            setCheckInfo(value);
        }));
    }, []);
    return { checkInfo, queryCheckInfo, loading: loading };
};
exports.useGFDWMarginCheckInfo = useGFDWMarginCheckInfo;
